import axios from "axios";

export const getPlateBuilderData = async () => {
    const plateBuilderData = await axios.get(`${numberplate.home_url}/wp-json/wp/v2/get-plates-info`)
    return JSON.parse(plateBuilderData.data)
}
